import React from 'react';

export interface KpiTileProps {
  label: string;
  value: string | number;
  sub?: string;
  accent?: 'default' | 'warning' | 'danger' | 'success';
}

const ACCENTS: Record<NonNullable<KpiTileProps['accent']>, string> = {
  default: 'border-l-brand-500',
  warning: 'border-l-yellow-500',
  danger: 'border-l-red-500',
  success: 'border-l-green-500',
};

export function KpiTile({
  label,
  value,
  sub,
  accent = 'default',
}: KpiTileProps): React.ReactElement {
  return (
    <div
      className={`bg-white border border-border rounded-lg p-4 border-l-4 ${ACCENTS[accent]}`}
    >
      <p className="text-xs font-medium uppercase tracking-wide text-text-muted">{label}</p>
      <p className="mt-1 text-3xl font-bold text-text-primary">{value}</p>
      {sub && <p className="mt-0.5 text-xs text-text-muted">{sub}</p>}
    </div>
  );
}
